import { Navigate } from "react-router-dom";
import { getDecodedToken, hasAccess } from "./auth";

const RoleProtectedRoute = ({ module, children }) => {
  const user = getDecodedToken();
  if (!user) return <Navigate to="/" replace />;

  const userRoles = Array.isArray(user.roles)
    ? user.roles
    : typeof user.role === "string"
    ? [user.role]
    : [];

  const requiredModules = module.includes(",")
    ? module.split(",").map((m) => m.trim())
    : [module];

  const isAllowed = requiredModules.some((mod) => hasAccess(mod, userRoles));

  return isAllowed ? children : <Navigate to="/home" replace />;
};

export default RoleProtectedRoute;
